import React from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField } from "@mui/material";
import dayjs from "dayjs";

const DateSelector = ({ title, selectedDate, onDateChange }) => {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <h4>{title}</h4>
            <DatePicker
                label="Select a Date"
                value={selectedDate ? dayjs(selectedDate) : null}
                onChange={(date) => onDateChange(date ? dayjs(date).format("YYYY-MM-DD") : "")}
                renderInput={(params) => <TextField {...params} fullWidth />}
                format="DD/MM/YYYY"
            />
        </LocalizationProvider>
    );
};

export default DateSelector;
